<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Cliente Resolvido"
      message="Você tem certeza que deseja marcar o cliente como resolvido?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="clients"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhum cliente encontrado"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Clientes não sincronizados no Sienge</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="reload" dark>Atualizar</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.name`]="{ item }">
         {{ item.client ? item.client.name : '' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="send(item)"
              >
                mdi-account-convert
              </v-icon>
            </template>
            <span>Solicitar reenvio</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="openConfirmModal(item)"
              >
                mdi-chevron-down-circle-outline
              </v-icon>
            </template>
            <span>Marcar como resolvido</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                @click="handleViewClient(item)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver cliente</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    itemToFinish: null,
    dialog: false,
    loading: true,
    loadingMessage: 'Carregando',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      { text: 'Nome', align: 'start', value: 'name' },
      { text: 'Descrição', value: 'description' },
      { text: 'Ações', value: 'actions', sortable: false, width: '160px', align: 'center' }
    ],
    clients: [],
    editedIndex: -1,
    confirmModal: false
  }),

  created () {
    this.getClients()
  },

  methods: {
    async getClients () {
      try {
        this.loading = true
        const { data } = await api.get('/clients/sienge')
        this.clients = data
      } catch (error) {
        message.error('Erro ao buscar clientes')
      } finally {
        this.loading = false
      }
    },

    reload () {
      this.getClients()
    },

    async finished () {
      try {
        this.loading = true
        api.put(`/clients/${this.itemToFinish.id}/sienge`)
        const index = this.clients.indexOf(this.itemToFinish)
        this.clients.splice(index, 1)
        message.success('Cliente Resolvido')
      } catch (error) {
        message.error('Erro na operação')
      } finally {
        this.loading = false
      }
    },

    async send (item) {
      try {
        this.loading = true
        api.post(`/clients/${item.client_id}/sienge`)
        const index = this.clients.indexOf(item)
        this.clients.splice(index, 1)
        message.success('Reenvio solicitado')
      } catch (error) {
        message.error('Erro ao solicitar reenvio')
      } finally {
        this.loading = false
      }
    },

    handleCancelConfirmModal () {
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.confirmModal = false
      this.finished()
    },

    openConfirmModal (item) {
      this.itemToFinish = item
      this.confirmModal = true
    },

    handleViewClient (item) {
      this.$router.push({ path: `/clientes/${item.client_id}/editar` })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clients/SiengeClients.vue